import { useCancelProcess } from "@/hooks/use-cancel-process";
import { useVocalRemoverProgressContext } from "@/components/pages/vocal-remover/providers/vocal-remover-progress-provider";

export const useCancelVocalRemove = () => {
  const progressContext = useVocalRemoverProgressContext();

  const { cancelProcess } = useCancelProcess(
    "/api/vocal-remove/cancel?",
    new URLSearchParams({
      vocal_remove_id: progressContext.processId!,
    }),
    () => progressContext.forceCancelCurrentProcess(),
  );

  return { cancelVocalRemove: cancelProcess };
};
